import m, {Vnode} from "mithril";

import {TextboxItem} from "../../../../model/items/textbox";
import {textboxItemView} from "../../../../ui/items/textbox";

export default class TextboxCell {

    private touched = false;

    constructor(
        public readonly textbox: TextboxItem
    ) { }


    public view(): Vnode|null {

        if (!this.textbox.cell.visible) {
            return null;
        }

        const error = this.touched ? this.textbox.validate() : undefined;
        const errorMessage = error?.messages.length ? error.messages[0] : "";

        const cssClass = 'TextboxCell' + (errorMessage ? ' invalid' : '') + (this.textbox.cell.cssClass ? (' '+this.textbox.cell.cssClass) : '');

        return m("div", {
            "class": cssClass
        }, [
            textboxItemView(this.textbox),
            (errorMessage) ? m('.validationBox', {}, m.trust(this.textbox.form.questionary.renderText(errorMessage)) ) : null,
        ]);
    }


}